import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    permission: [],

    user: {
      name: ''
    },
    userData: null
  },
  mutations: {
    setPermission (state, payload) {
      state.permission = payload
    },
    setUserData (state, payload) {
      state.userData = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
